<template>
  <v-row no-gutters>
    <v-col cols="12" class="pa-0">
      <v-row no-gutters align="start">
        <v-col class="px-5 py-6" cols="4">
          <div style="text-align: left" class="pa-0 pt-2">{{ $i18n.t('dialog.attachments.file') }}</div>
        </v-col>
        <v-col cols="4" class="px-5 py-6">
          <file-input
            ref="file"
            :options="dropzoneOptions"
            :show-added-files="true"
            :events="{
              'vdropzone-success': onUploadSuccess,
              'vdropzone-sending': sendingEvent,
              'vdropzone-error': onError,
              'vdropzone-file-added': onFileAdded,
              'vdropzone-removed-file': onFileRemoved,
            }"
          ></file-input>
        </v-col>
      </v-row>
      <template v-if="expanded">
        <v-row no-gutters align="center" v-for="(attribute, idx) of formSchema" :key="idx" style="min-height: 66px">
          <v-col class="px-5 pt-2" cols="4" align-self="start">
            <div style="text-align: left" class="pa-0" :class="{ 'text--disabled': !attribute.editable }">
              {{ attribute.label }}:
            </div>
          </v-col>
          <v-col cols="4" class="px-5">
            <v-tooltip bottom color="font" :disabled="attribute.editable">
              <template #activator="{ on }">
                <span v-on="on">
                  <data-input
                    v-bind="{ ...attribute, ...(attribute.editable ? {} : { backgroundColor: '#f0f0f0' }) }"
                    v-model="values[attribute.attribute]"
                    :disabled="!attribute.editable"
                    label=""
                    hide-name-column
                  />
                </span>
              </template>
              {{ $i18n.t('sidebar.noEditingAvailable', { name: attribute.label }) }}
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import { call } from 'vuex-pathify';
import DataInput from '@/components/DataInput';
import FileInput from '@/components/FileInput';

export default {
  name: 'AddAttachmentTab',
  components: { DataInput, FileInput },
  props: {
    features: {
      type: Array,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    formSchema: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    dropzoneOptions() {
      const self = this;
      return {
        url: `${process.env.VUE_APP_API_URL}/attachments`,
        method: 'post',
        autoProcessQueue: false,
        uploadMultiple: !this.expanded,
        addRemoveLinks: true,
        paramName: 'file',
        ...(this.expanded ? { maxFiles: 1 } : {}),
        init: function() {
          this.on('maxfilesexceeded', function(file) {
            if (self.expanded) {
              this.removeAllFiles();
              this.addFile(file);
            }
          });
        },
      };
    },
  },
  data: () => ({
    values: {},
  }),
  methods: {
    addAttachment: call('relations/addAttachment'),
    onError() {
      this.$refs.file.$refs.dropzone.removeAllFiles();
      this.$emit('fileError');
    },
    onUploadSuccess() {
      this.$refs.file.$refs.dropzone.removeAllFiles();
      this.$emit('fileUploaded');
    },
    onFileAdded(file) {
      if (!this.values.name) {
        const filename = file.name
          .split('.')
          .slice(0, -1)
          .join('.');
        this.$set(this.values, 'name', filename);
      }
      this.$emit('fileAdded', file);
    },
    onFileRemoved(file) {
      this.$emit('fileRemoved', file);
    },
    async uploadFiles() {
      if (this.expanded) {
        this.$refs.file.$refs.dropzone.processQueue();
      } else {
        try {
          const formData = new FormData();
          const arrString = this.features.map(a => `${a.datasource_name}.${a.id}`).toString();
          for (const file of this.$refs.file.$refs.dropzone.getAcceptedFiles()) {
            formData.append('file', file);
            formData.append('name', file.name);
            formData.append('target_objects', arrString);
          }
          await this.addAttachment(formData);
          this.onUploadSuccess();
        } catch {
          this.onError();
        }
      }
    },
    sendingEvent(files, xhr, formData) {
      const arrString = this.features.map(a => `${a.datasource_name}.${a.id}`).toString();
      formData.append('target_objects', arrString);
      if (this.expanded) {
        for (const key of Object.keys(this.values)) {
          const value = this.values[key];
          if (!value && value !== false && value !== 0) {
            continue;
          }
          formData.append(key, this.values[key]);
        }
      }
    },
  },
};
</script>

<style scoped></style>
